import React, { FC } from 'react';

import Button from '../../components/Button';
import translate from '../../translate';

export interface ActionProps {
    newEmailTemplate: any;
    saveTemplate: any;
    deleteTemplate: any;
    duplicateTemplate: any;
    disableEdit: boolean;
}

const Actions: FC<ActionProps> = (props) => {
    if (props.disableEdit) {
        return null;
    }

    if (props.newEmailTemplate) {
        return (
            <Button color="primary" variant="contained" onClick={() => props.saveTemplate()}>
                {translate('emailTemplateDetail.createEmailTemplate')}
            </Button>
        );
    }
    return (
        <div style={{ display: "flex", columnGap: "5px", justifyContent: "left", }}>
            <Button color="primary" variant="contained" onClick={props.deleteTemplate}>
                {translate('emailTemplateDetail.deleteEmailTemplate')}
            </Button>
            <Button color="primary" variant="contained" onClick={props.duplicateTemplate}>
                {translate('emailTemplateDetail.duplicateEmailTemplate')}
            </Button>

            <Button color="primary" variant="contained" onClick={() => props.saveTemplate()}>
                {translate('emailTemplateDetail.editEmailTemplate')}
            </Button>
        </div>
    );
};

export default Actions;
